import React, { useEffect, useMemo, useState } from 'react';
import {
  MdOutlineExitToApp,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';
import { BiUser } from 'react-icons/bi';

import Avatar from 'components/Granel/Avatar';
import DropdownWrapper from 'components/layout/DropdownWrapper';
import { getContactDisplayName, getUserData } from 'services/userServices';
import { signOut } from 'utils/functions';

import {
  AccountContainer,
  AvatarContainer,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownText,
  IconContainer,
  InfoContainer,
  UserName,
} from './styles';

const truncateUserName = (name: string, maxLength = 30): string => {
  if (name.length <= maxLength) {
    return name;
  }

  return `${name.slice(0, maxLength).trimEnd()}...`;
};

const UserMenuIcon = (): JSX.Element => {
  const [show, setShow] = useState(false);
  const [profileName, setProfileName] = useState('');

  useEffect(() => {
    let isMounted = true;

    getUserData()
      .then((userData) => {
        if (!isMounted) {
          return;
        }

        setProfileName(getContactDisplayName(userData));
      })
      .catch(() => {});

    return () => {
      isMounted = false;
    };
  }, []);

  const displayUserName = useMemo(
    () => (profileName ? truncateUserName(profileName) : ''),
    [profileName]
  );

  const toggleShow = (): void => {
    setShow((prevState) => !prevState);
  };

  const routePerfil = (): void => {
    window.location.href = '/perfil';
  };

  return (
    <Container>
      <AccountContainer onClick={toggleShow}>
        <AvatarContainer>
          <Avatar />
        </AvatarContainer>
        {displayUserName && (
          <InfoContainer>
            <UserName title={profileName}>{displayUserName}</UserName>
          </InfoContainer>
        )}
        <IconContainer>
          {show ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
        </IconContainer>
      </AccountContainer>
      {show && (
        <DropdownWrapper hideDropdown={toggleShow}>
          <DropdownMenu>
            <DropdownItem onClick={routePerfil}>
              <BiUser />
              <DropdownText>Perfil</DropdownText>
            </DropdownItem>
            <DropdownItem onClick={signOut}>
              <MdOutlineExitToApp />
              <DropdownText>Sair</DropdownText>
            </DropdownItem>
          </DropdownMenu>
        </DropdownWrapper>
      )}
    </Container>
  );
};

export default UserMenuIcon;
